import { useState, useCallback, useEffect } from "react";
import { TextareaAutosize, TextField } from "@mui/material";

import Table from "../../components/Table";
import Dialog from "../../components/Dialog";
import {
  useActivateInstructor,
  useCreateInstructor,
  useGetInstructors,
  usePatchInstructor,
} from "../../api/instructorApi";
import { instructorTableDef } from "../../table/InstructorTableDef";
import { Instructor } from "../../types/instructor";

const ManageInstructor = () => {
  const { data: instructorList } = useGetInstructors();
  const { mutateAsync: patchInstructor } = usePatchInstructor();
  const { mutateAsync: createInstructor } = useCreateInstructor();
  const { mutateAsync: activateInstructor } = useActivateInstructor();
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState<number>();

  return (
    <div>
      <button onClick={() => setOpenCreateDialog(true)} className="moveButton">
        추가하기
      </button>
      <Table
        columns={instructorTableDef({
          activateInstructor,
          editInstructor: (id) => setOpenEditDialog(id),
        })}
        data={instructorList || []}
        columnPinning={{}}
      />
      {openCreateDialog && (
        <EditInstructor
          original={{}}
          close={() => setOpenCreateDialog(false)}
          submit={async (data) => {
            createInstructor(data);
          }}
        />
      )}
      {openEditDialog && (
        <EditInstructor
          original={instructorList?.find(
            (instructor: Instructor) => instructor.id === openEditDialog
          )}
          close={() => setOpenEditDialog(undefined)}
          submit={async (data) => {
            patchInstructor(data);
          }}
        />
      )}
    </div>
  );
};

const EditInstructor = ({
  original,
  close,
  submit,
}: {
  original: any;
  close: () => void;
  submit: (data: any) => Promise<void>;
}) => {
  const [editData, setEditData] = useState<Record<string, any>>({});

  useEffect(() => {
    setEditData(original);
  }, [original]);

  const saveEditData = useCallback((key: string, value: any) => {
    setEditData((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleSubmit = async () => {
    if (
      !editData.name ||
      !editData.email ||
      !editData.corp_name ||
      !editData.corp_address
    ) {
      alert("모든 항목을 입력해주세요.");
      return;
    }

    const data = Object.fromEntries(
      Object.entries(editData).filter(([key, value]) => value !== original[key])
    );
    data.id = original.id;

    try {
      await submit(data);
      alert("성공적으로 등록했습니다.");
      close();
    } catch (e) {
      console.error(e);
      alert("추가/수정 중 오류가 발생했습니다.");
    }
  };

  return (
    <Dialog
      title="지도자 추가/수정"
      buttons={["close", "ok"]}
      ok={async () => {
        await handleSubmit();
      }}
      close={close}
    >
      <div className="binary-grid">
        <>
          <p>강사 이름</p>
          <TextField
            fullWidth
            variant="standard"
            value={editData.name || ""}
            onChange={(e) => {
              saveEditData("name", e.target.value);
            }}
          />
        </>
        <>
          <p>강사 이메일</p>
          <TextField
            fullWidth
            variant="standard"
            value={editData.email || ""}
            onChange={(e) => {
              saveEditData("email", e.target.value);
            }}
          />
        </>
        <>
          <p>기관 이름</p>
          <TextField
            fullWidth
            variant="standard"
            value={editData.corp_name || ""}
            onChange={(e) => {
              saveEditData("corp_name", e.target.value);
            }}
          />
        </>
        <>
          <p>기관 주소</p>
          <TextareaAutosize
            maxRows={3}
            value={editData.corp_address || ""}
            onChange={(e) => saveEditData("corp_address", e.target.value)}
          />
        </>
      </div>
    </Dialog>
  );
};

export default ManageInstructor;
